import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  row: {
    flexDirection: 'row',
    marginTop: 15,
    paddingLeft: 73,
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iconTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 11,
  },
  text: {
    fontSize: 18.7,
    lineHeight: 25,
    paddingTop: Platform.OS === 'ios' ? 5 : null,
  },
});
